import React 			from 'react';
import PropTypes 	from 'prop-types';

//this.props.classes			: string of classes
//this.props.onClickFunc	: function to handle selecting
//this.props.isChecked		: whether the radio is active or not
//this.props.type					: dark || light

export default class InputSwitch extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', disabled = false} = this.props;

		return (
			<label className={"input-switch " + classes}>
				<input type="checkbox" className="input-switch__checkbox" checked={this.props.isChecked} disabled={disabled} onChange={!disabled ? (e) => this.props.onClickFunc(e.target.checked) : null}/>
				<span className={"input-switch__display " + (this.props.type == 'dark' ? "input-switch__display--dark" : "") + (this.props.type == 'lightblue' ? "input-switch__display--lightblue" : "") + (this.props.type == 'transparent' ? "input-switch__display--transparent" : "")}></span>
			</label>
		);
	}
}

InputSwitch.propTypes = {
		classes: PropTypes.string
	,	onClickFunc: PropTypes.func.isRequired
	,	isChecked: PropTypes.bool.isRequired
	,	type: PropTypes.oneOf(['dark', 'light', 'lightblue', 'transparent'])
	,	disabled: PropTypes.bool
}